import { render, staticRenderFns } from "./CompanySelector.vue?vue&type=template&id=2d8ff2c0"
import script from "./CompanySelector.vue?vue&type=script&lang=js"
export * from "./CompanySelector.vue?vue&type=script&lang=js"
import style0 from "./CompanySelector.vue?vue&type=style&index=0&id=2d8ff2c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports